import { PositionOrgChart } from "../Model/PositionOrgChart";

export class GetPositionOrgChartList {
  constructor(
    total,
    offset,
    limit,
    records,
  ) {
      this.total = total;
      this.offset = offset;
      this.limit = limit;
      this.records = records;
  }
  static createFromResponseData(data) {
    return new GetPositionOrgChartList(
      data.total,
      data.offset,
      data.limit,
      data.records.map((record) => {
        return PositionOrgChart.createFromResponseData(record);
      }),
    );
  }
};